<div class="flex h-full">
    <div class="w-full min-h-full">
        <ng-content />
    </div>
    @if (isLoggedIn && displaySidepanel){
        <app-side-panel class="hidden lg:block absolute right-0 translate-x-full md:translate-x-0 md:relative md:justify-end -me-8" />
    }
</div>